<!-- 应用列表 -->
<template>
  <div class="applist">
    <!-- 背景图 -->
    <TopImg :title="topImg.title" :content="topImg.content" :image="topImg.bgImg" :bl="topImg.bl"></TopImg>
    <div class="barPath width">
      <el-breadcrumb separator="/">
        <el-breadcrumb-item :to="{ path: '/appmarket' }">应用市场</el-breadcrumb-item>
        <el-breadcrumb-item :to="{ path: '/appList' }">应用列表</el-breadcrumb-item>
        <el-breadcrumb-item>智能制造生产管理学系统</el-breadcrumb-item>
      </el-breadcrumb>
    </div>
    <div class="applistDetails width">
      <div class="detailsContent">
        <div class="con">
          <div class="imgs">
            <img :src="classData.cover_photo" alt srcset />
          </div>
          <div class="detailsCon">
            <div class="title">{{classData.name}}</div>
            <div class="pp">
              <p>{{classData.introduction}}</p>
            </div>
            <div class="price" v-if="classDataLever">
              <span class="p_price">价格：</span>
              <strong>
                <span class="s_price">价格:</span>
                <span
                  class="c_price"
                >￥{{classDataLever&&classDataLever[this.i].price>0?classDataLever[this.i].price+'/'+classDataLever[this.i].mname:classDataLever[this.i].mname}}</span>
              </strong>

              <!-- <span class="timePrice">/使用7天</span> -->
            </div>
            <div class="edition">
              <span class="aa">版本</span>
              <span
                class="a1"
                v-for="(item,i) in classDataLever"
                :key="i"
                @click="editionClick(i)"
                :class="i==index?'act':''"
              >{{item.name}}</span>
            </div>
            <div class="paynum">
              <span class="aa">数量</span>
              <el-input-number
                v-model="payArr.count"
                :min="1"
                label="描述文字"
                :disabled="disable"
                size="small"
              ></el-input-number>
            </div>

            <div class="pay">
              <!-- <router-link tag="a" target="_blank" to="pay"> -->
              <el-button type="primary" @click="byOrder">立即购买</el-button>
              <!-- </router-link> -->
            </div>
          </div>
        </div>
        <div class="listTab">
          <el-tabs v-model="activeName" @tab-click="handleClick">
            <el-tab-pane label="产品详情" name="1">暂无</el-tab-pane>
            <el-tab-pane label="产品价格" name="2">暂无</el-tab-pane>
            <el-tab-pane label="使用指南" name="3">暂无</el-tab-pane>
            <el-tab-pane label="评论详情" name="4">暂无</el-tab-pane>
          </el-tabs>
        </div>
      </div>
      <div class="detailsDe">
        <div class="title">
          <span>服务商：{{classData.pname}}</span>
        </div>
        <div class="xian"></div>
        <div class="webs">公司网址：{{classData.website}}</div>
        <div class="webs">联系邮箱：{{classData.conemail}}</div>
        <div class="lever">
          <span>服务商等级</span>
          <div class="immg">
            <img v-if="classData.lever==1" src="../assets/images/icon1.png" alt srcset />
            <img v-if="classData.lever==2" src="../assets/images/icon2.png" alt srcset />
            <img v-if="classData.lever==3" src="../assets/images/icon3.png" alt srcset />
            <img v-if="classData.lever==4" src="../assets/images/icon4.png" alt srcset />
          </div>
        </div>
        <div class="xian"></div>
        <div class="content">
          <div class="con_title">服务商业务介绍：</div>
          <div class="con_pp">{{classData.pcontent}}</div>
        </div>
      </div>
    </div>
    <!-- 底部 -->
    <div class="el-footer">
      <Footer />
    </div>
  </div>
</template>

<script>
import TopImg from '../components/TopImg'
import Footer from '../components/Footer.vue'
export default {
  name: '',
  components: { TopImg, Footer },
  props: {},
  data() {
    return {
      topImg: {
        title: '',
        bgImg: require('../assets/images/u1.png'),
        content: '',
        bl: false,
      },
      classData: {},
      classDataLever: {},
      activeName: '1',
      i: 0,
      index: '',
      infoPar: '',
      payorder: '',
      payArr: { count: '' },
      disable: false,
    }
  },
  computed: {},
  watch: {},
  created() {
    var zg = Object.values(this.$route.params)
    if (zg.length > 0) {
      sessionStorage.setItem('appinfoPar', JSON.stringify(this.$route.params))
    }
    this.getClassify()
  },
  mounted() {},
  methods: {
    async getClassify() {
      this.infoPar = JSON.parse(sessionStorage.getItem('appinfoPar'))
      const res = await this.$http.post('/getAppinfo', this.infoPar)
      this.classData = res.data.data.appinfo
      this.classDataLever = res.data.data.leverinfo
      this.payArr.paice = res.data.data.leverinfo[0].price
      this.payArr.leverid = res.data.data.leverinfo[0].id
      this.payArr.mname = res.data.data.leverinfo[0].mname
      if (this.payArr.paice == 0) {
        this.disable = true
      } else {
        this.disable = false
      }
    },
    async byOrder() {
      if (sessionStorage.getItem('codes')) {
        this.payArr.codes = sessionStorage.getItem('codes')
        this.payArr.total_amount = this.payArr.count * this.payArr.paice
        this.payArr.appid = this.classData.id
        const res = await this.$https.post('/payorder', this.payArr)
        if (res.data.code == '0001') {
          this.$message({
            message: res.data.message,
            type: 'warning',
          })
        } else {
          let { href } = this.$router.resolve({
            path: '/pay',
          })
          window.open(href, '_blank')
          this.$message({
            message: res.data.message,
            type: 'success',
          })
        }
        localStorage.setItem('datadorm', JSON.stringify(res.data))
      } else {
        this.$message.error('请先登录您的账号')
        this.$router.push('login')
      }
    },
    editionClick(i) {
      this.i = i
      this.index = i
      this.payArr.paice = this.classDataLever[i].price
      this.payArr.leverid = this.classDataLever[i].id
      this.payArr.mname = this.classDataLever[i].mname
      if (this.payArr.paice == 0) {
        this.disable = true
        this.payArr.count = 1
      } else {
        this.disable = false
      }
    },

    handleClick(tab, event) {
      // console.log(tab, event)
    },
  },
}
</script>

<style lang="less" scoped>
.barPath {
  height: 48px;
  line-height: 48px;
  background-color: #fff;
  padding-left: 20px;
  box-sizing: border-box;
  margin-bottom: 10px;
  .el-breadcrumb {
    line-height: 48px;
    font-size: 16px !important;
  }
}
.applistDetails {
  display: flex;
  .detailsContent {
    flex: 6;
    .con {
      display: flex;
      padding: 20px 20px;
      box-sizing: border-box;
      background-color: #fff;
      .imgs {
        flex: 1;
        img {
          width: 100%;
        }
      }
      .detailsCon {
        flex: 6;
        margin-left: 20px;
        .title {
          font-weight: 700;
          font-size: 18px;
        }
        .pp {
          p {
            line-height: 23px;
            max-width: 800px;
          }
        }
        .price {
          margin: 20px 0;
          .p_price {
          }
          .s_price {
            font-weight: 700;
            font-size: 18px;
          }
          .c_price {
            font-weight: 700;
            font-size: 18px;
            color: #d9001b;
          }
        }
        .edition {
          align-items: center;
          margin-bottom: 20px;
          span {
            display: inline-block;
            max-width: 60px;
            margin-right: 10px;
          }
          .a1 {
            display: inline-block;
            font-size: 16px;
            cursor: pointer;
            max-width: 80px;
          }

          .act {
            color: #0079fe;
          }
        }
      }
    }
    .listTab {
      background-color: #fff;
      padding: 20px;
      box-sizing: border-box;
      margin-top: 10px;
    }
  }
  .detailsDe {
    flex: 2;
    max-width: 300px;
    background-color: #fff;
    margin-left: 30px;
    padding: 20px 30px;
    box-sizing: border-box;
    .xian {
      display: block;
      height: 1px;
      background-color: #ccc;
      width: 90%;
      margin: 0 auto;
    }
    .title {
      margin: 20px 0;
    }
    .webs {
      margin: 20px 0;
    }
    .lever {
      display: flex;
      margin: 20px 0;
      // justify-content: center;
      align-items: center;
      span {
        flex: 1;
      }
      .immg {
        flex: 2;
        img {
          max-width: 30px;
        }
      }
    }
    .content {
      margin: 20px 0;
      .con_title {
        margin-bottom: 5px;
      }
      .con_pp {
        line-height: 18px;
      }
    }
  }
  .paynum {
    margin-bottom: 20px;
    .aa {
      margin-right: 10px;
    }
  }
}
</style>
